'use es6';

import { createSelector } from 'reselect';
import { fromJS, List } from 'immutable';
import requestStatusType from '../constants/requestStatusTypes';
import { selectReportTemplates, selectReportTemplatesStatus } from './reportsSelector';
const {
  SUCCEEDED
} = requestStatusType;
export const selectTemplateGridData = createSelector(selectReportTemplatesStatus, selectReportTemplates, (reportTemplatesStatus, templates) => {
  return reportTemplatesStatus === SUCCEEDED ? fromJS(templates) : List();
});